module.exports = __webpack_public_path__ + "assets/big_green_check-f5645a.svg";